export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      position: 'absolute',
      top: '10px',
      right: '-10px',
      transform: 'translateY(-100%)',
      pointerEvents: 'none',
      userSelect: 'none',
      borderRadius: '3px',
      backgroundColor: colors.secondary,
      color: colors.white,
      fontSize: '14px',
      lineHeight: '18px',
      zIndex: 100,
      width: '210px',
      padding: '8px 20px',
      opacity: 0,
      transition: 'opacity .3s',
      boxShadow: 'inset 0 1px 2px 0 rgba(0,0,0,0.34), 0 2px 2px 0 rgba(0,0,0,0.05)',
      '&:after': {
        content: '""',
        pointerEvents: 'none',
        position: 'absolute',
        top: 'calc(100% - 7px)',
        left: '50%',
        transform: 'translateX(-50%) rotate(45deg)',
        backgroundColor: colors.secondary,
        height: '15px',
        width: '15px'
      }
    },
    visible: {
      opacity: 1
    }
  };
});